import { AssignmentMode, UserType } from '../gql/generated/graphql';

export const MAX_MAX_AUTO_ASSIGN_DEALS = 15;
export const MIN_MAX_AUTO_ASSIGN_DEALS = 0;

export const DEFAULT_USER_TYPE = UserType.Human;
export const DEFAULT_ASSIGNMENT_MODE = AssignmentMode.MaxDeals;
export const DEFAULT_FREQUENCY_MINUTES = 30;
